/* Created by: Murugaeswari
  Created At: 28-04-2025
  Description: Subscription Plan List Page
  Updated by: kani
*/

import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
//import components
import PaginationTableContainer from '../../../components/Common/PaginationTableContainer';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import DeleteModal from "../../../components/Common/DeleteModal";
import PublishModal from "../../../components/Common/PublishModal";
import Select from "react-select";
import * as url from "../../../../src/helpers/url_helper";
import { getLoggedInUser, getRefreshToken } from "../../../helpers/fakebackend_helper";
import * as constants from "../../../constants/layout"
//Import Flatepicker
 //import "./studymaterials.scss"
import "flatpickr/dist/themes/material_blue.css";
import { Button, Col, Row, UncontrolledTooltip, Container, Form, Label, Card, CardBody, Badge } from "reactstrap";
import Spinners from "../../../components/Common/Spinner";

const SubscriptionPlan = () => {
  document.title = "Subscription Plan";
  const user = getLoggedInUser()
  const [plan, setPlan] = useState();
  const [planData, setPlanData] = useState();
  const [isLoading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [publishModal, setPublishModal] = useState(false);
  const [publishContent,setPublishContent] = useState();
  const navigate = useNavigate();
  const [canView, setCanView] = useState(false)
  const [canCreate, setCanCreate] = useState(false)
  const [canModify, setCanModify] = useState(false)
  const [canRemove, setCanRemove] = useState(false)
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const perPageData = 8;
  const [approveStatus, setApproveStatus] = useState([]);

  const [current, setCurrent] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [optionPlanCategory , setOptionPlanCategory] = useState([]);
  const [optionStatus , setOptionStatus] = useState([]);
  const [selectedStatus, setselectedStatus] = useState(null);
  const [selectedPublish, setSelectedPublish] = useState(null);
  const [selectedPlanCategoryName, setSelectedPlanCategoryName] = useState(null);
  const [filterData, setFilterData] = useState({

    selectedPlanCategoryName: 0,
    selectedTopicName: 0,
    selectedStatus: 0,
    selectedPublish: 0,
 
  })
  useEffect(() => {
   
    document.title = "Subscription Plan | TNPSC";
    document.getElementById('headerTitle').innerHTML = 'Subscription Plan';

    setselectedStatus({
      label: "All",
      value: 0
    })
    setSelectedPlanCategoryName({
      label: "All",
      value: 0
    })
    setSelectedPublish({
      label: "All",
      value: 0
    })

  }, []);

  useEffect(() => {
    getmasterdatalistapi()
}, []);

const getmasterdatalistapi = async () => {
    try{
        const data = { user_id: Number(user.uid) }
        const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
        const response1 = await axios.post(url.BASE_URL + 'subscriptionplan/getSPMaster', data, config)
        if (response1 && response1.data && response1.data && response1.data.status === 200) {

          setOptionPlanCategory(response1?.data?.body?.subscriptionCategory)
            setOptionStatus(response1?.data?.body?.subscriptionStatus)
            setApproveStatus(response1?.data?.body?.publishStatus)
            if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
                const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
                if (refresh) {
                    if (Number(refresh) === constants.invalidRefreshToken) {
                        logoutUser()
                    } else {
                        await getmasterdatalistapi() // calling same function again getting refresh token
                    }
                }
            }
        }
    }
    catch(e)

    {
        console.log(e,'e')
    }

   
}

  useEffect(() => {

    var page_indexOfLast = currentPage * perPageData;
    var offset = page_indexOfLast - perPageData;
    GetPlanList(offset);

  }, [filterData, currentPage]);
  useEffect(() => {
    if (current) {
      GetPlanList(current)
    }
    setCurrent(0)
  }, [current])


  var planListData;

  async function GetPlanList(offset) {
    setLoading(true);
    const user = getLoggedInUser()

    if (filterData.selectedSubjectName != 0) {
      var st_sid = filterData.selectedSubjectName
    } else var st_sid = 0

    const filter_user_id = user?.user_previleges.find(f =>
      Number(f.urp_mid) === constants.mainMenuList.SubscriptionPlan && f.urp_type === constants.menuTypes.View);

    const data = {
      "user_id": Number(user.uid),
      "category_id": Number(filterData?.selectedPlanCategoryName),
      "status": Number(filterData?.selectedStatus),
      "publish_status": Number(filterData?.selectedPublish),
      "search_data": filterData?.selectedTopicName ? filterData?.selectedTopicName : "",
      "limit": 10,
      "offset": Number(current) != 0 ? Number(current - 1) : 0,
    }
    console.log('da6a', data)
    const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
    const response1 = await axios.post(url.BASE_URL + 'subscriptionplan/getPlanList', data, config)
    if (response1 && response1.statusFlag === 3) { // user validation
      setLoading(false);
      toast.error(response1.message, { autoClose: 2000 });
      localStorage.removeItem("authUser");
      sessionStorage.removeItem("SESSION_KEY")
      window.location.reload()
      return
    }
    if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
      setLoading(false);
      const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
      if (refresh) {
        if (Number(refresh) === constants.invalidRefreshToken) {
          logoutUser()
        } else {
          GetPlanList(offset) // calling same function again getting refresh token
        }
      }
    }
    if (response1 && response1.data && response1.data.body) {
      setPlanData(response1.data.body.planList)
      planListData = response1.data.body.planList;
      setTotalCount(response1.data.body.planCount)
      setLoading(false);
      return { statusFlag: response1.data.body.statusFlag, message: response1.data.body.message }
    } else {
      setLoading(false);
      return { statusFlag: 2, message: 'Something went wrong' }
    }

  }






  const columns = useMemo(
    () => [
      {
        header: 'Actions',
        // accessorKey: 'action',
        // enableColumnFilter: false,
        // enableSorting: true,

        width: '8%',
        // width: (cell) => cell.value.length * 10, 
        cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
            
              {user && user.user_previleges && user.user_previleges.find(f =>
                Number(f.urp_smid) === constants.SubmenuList.SubscriptionPlan
                &&
                f.urp_type === constants.menuTypes.Modify
                || f.urp_type === constants.menuTypes.Special
              ) && (
                  <div
                    to="#"
                    className="btn btn-sm btn-soft-info"
                    onClick={() => {
                      localStorage.setItem('isPlanClone', '0');
                      navigate(`/create-subscription/${cellProps.row.original.plan_id}`);
                    }}
                  >
                    <i className="mdi mdi-pencil-outline" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </div>
                )}
                 
              {user && user.user_previleges && user.user_previleges.find(f =>
                Number(f.urp_smid) === constants.SubmenuList.SubscriptionPlan && f.urp_type === constants.menuTypes.Remove) && (
                  <div
                    to="#"
                    className="btn btn-sm btn-soft-danger"
                    hidden =  {cellProps.row.original.publish_flag==1 ?true:false}
                    onClick={() => {
                      const planData = cellProps.row.original; onClickDelete(planData);
                    }}>
                    <i className="mdi mdi-delete-outline" id="deletetooltip" />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </div>)}

                  {cellProps.row.original.publish_flag==0 && user && user.user_previleges && user.user_previleges.find(f =>
                Number(f.urp_smid) === constants.SubmenuList.SubscriptionPlan
                &&
                f.urp_type === constants.menuTypes.Modify
                || f.urp_type === constants.menuTypes.Special
              ) && (
                  <div
                    to="#"
                    className="btn btn-sm btn-soft-success"
                    onClick={() => {
                      const planData = cellProps.row.original; onClickPublish(planData);
                    }}
                  >
                    <i className="mdi mdi-publish" id="publishtooltip" />
                    <UncontrolledTooltip placement="top" target="publishtooltip">
                      Publish
                    </UncontrolledTooltip>
                  </div>
                )}

              {cellProps.row.original.publish_flag==1 && cellProps.row.original.subscription_count==0 && user && user.user_previleges && user.user_previleges.find(f =>
                Number(f.urp_smid) === constants.SubmenuList.SubscriptionPlan
                &&
                f.urp_type === constants.menuTypes.Modify
                || f.urp_type === constants.menuTypes.Special
              ) && (
                <div
                to="#"
                className="btn btn-sm btn-soft-warning"
                onClick={() => {
                  const planData = cellProps.row.original; onClickUnPublish(planData);
                }}
              >
                <i className="mdi mdi-bookmark-remove-outline" id="unpublishtooltip" />
                <UncontrolledTooltip placement="top" target="unpublishtooltip">
                  Revert Publish
                </UncontrolledTooltip>
              </div>
                )}
                
            </div>
          );
        }
      },
      {
        header: 'S.No.',
        accessorKey: 'sno',
        width: '8%',
        enableColumnFilter: false,
        enableSorting: true,
        className: 'pl-25',
        cell: (cellProps) => {
          var data = cellProps.row.original.rno
          return (
            <div className="d-flex align-items-center">
              <span>{data}</span>
            </div>
          );


        }
      },
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
            Plan Name ▼
          </span>
        ),

        accessorKey: 'plan_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
    
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
           Plan Category ▼
          </span>
        ),

        accessorKey: 'category_name',
        enableColumnFilter: false,
        enableSorting: true,
      },
          
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
         Amount ▼
          </span>
        ),

        accessorKey: 'amount',
        enableColumnFilter: false,
        enableSorting: true,
        className: 'text-center',
      },

      {
        header: (
          <span style={{ cursor: 'pointer' }}>
         Validity ▼
          </span>
        ),

        accessorKey: 'validity_in_days',
        enableColumnFilter: false,
        enableSorting: true,
      },

       {
        header: 'English',
        accessorKey: 'tot_blueprint_english',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          
          return (
            <div className="d-flex align-items-center">
              {cellProps.row.original.noshortage_english+'/'+cellProps.row.original.tot_blueprint_english}
             
            </div>
          );
        },
      },
        {
        header: 'Regional',
        accessorKey: 'tot_blueprint_tamil',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          return (
            <div className="d-flex align-items-center">
              {cellProps.row.original.noshortage_tamil+'/'+cellProps.row.original.tot_blueprint_tamil}
             
            </div>
          );
        },
      },
   
      {
        header: 'Status',
        accessorKey: 'st_stsid',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          const c_stsid = cellProps.row.original.sp_status;

          return (
            <div className="d-flex align-items-center">
              {c_stsid == "1" ? (
                <i className="mdi mdi-check-circle text-success me-2" style={{ fontSize: '25px' }} />
              ) : c_stsid == "2" ? (
                <i className="bx bx-x
 text-danger me-2" style={{ fontSize: '20px' }} />
              ) : 
                    ""}
            </div>
          );
        },
      },
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
            Created By ▼
          </span>
        ),

        accessorKey: 'created_by',
        enableColumnFilter: false,
        enableSorting: true,
      },
 
      {
        header: (
          <span style={{ cursor: 'pointer' }}>
            Updated By ▼
          </span>
        ),

        accessorKey: 'updated_by',
        // enableColumnFilter: false,
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => {
          const mk_stsid = cellProps.row.original.updated_by;

          return (
            <div className="d-flex align-items-center">
              {mk_stsid ? (
                <span>{mk_stsid}</span>
              ) : (
                <span>-</span>
              )}
            </div>
          );
        },
      }

    ],
    [planListData, selectedRows]
  );



  function handleSelectPlanCategoryName(option) {
    setSelectedPlanCategoryName(option);

  }




  function handleSelectStatus(varselectedStatus) {
    setselectedStatus(varselectedStatus);
  }
  function handleSelectApproveStatus(varselectedStatus) {
    setSelectedPublish(varselectedStatus);
  }

  const onClickDelete = (planData) => {
    setPlan(planData.plan_id);
    setDeleteModal(true);
  };
  const onClickPublish = (planData) => {
    setPlan(planData.plan_id);
    setPublishContent(constants.modalText.PUBLISHPLAN)
    setPublishModal(true);
  };
  const onClickUnPublish = (planData) => {
    setPlan(planData.plan_id);
    setPublishContent(constants.modalText.UNPUBLISHPLAN)
    setPublishModal(true);
    
  };
  
  const handleDeletePlan = async () => {
    setLoading(true);
    const data = {
      user_id: Number(user.uid),
      plan_id: Number(plan)
    };
    const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
    try {
      const response = await axios.post(url.BASE_URL + 'subscriptionplan/deleteSubscriptionPlan', data, config);
      if (response && response.statusFlag === 3) {
        setLoading(false);
        toast.error(response.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        sessionStorage.removeItem("SESSION_KEY")
        window.location.reload();
        return;
      }
      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();
        setLoading(false);
        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await handleDeletePlan();
          }
        }
      }
      setLoading(false);
      if (response?.data?.body?.statusFlag === 1) {
        toast.success(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
      console.error(error);
    } finally {
      setPlan(null);
      setLoading(false);
      setPublishContent('');
      setDeleteModal(false);
      await GetPlanList(0);
    }
  };

  /**
   * Handles publishing a plan.
   * @async
   * @function
   */
  const handlePublishPlan = async () => {
    setLoading(true);
    const data = {
      user_id: Number(user.uid),
      plan_id: Number(plan)
    };
    const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } };
    try {
      const response = await axios.post(url.BASE_URL + 'subscriptionplan/publishSubscriptionPlan', data, config);
      if (response && response.statusFlag === 3) {
        setLoading(false);
        toast.error(response.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        sessionStorage.removeItem("SESSION_KEY")
        window.location.reload();
        return;
      }
      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        setLoading(false);
        const refresh = await getRefreshToken();
        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await handlePublishPlan();
          }
        }
      }
      setLoading(false);
      if (response?.data?.body?.statusFlag === 1) {
        toast.success(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
      console.error(error);
    } finally {
      setPlan(null);
      setLoading(false);
      setPublishModal(false);
      await GetPlanList(0);
    }
  };

  //USer role credentials
  useEffect(() => {
    
    if (user && user.user_previleges) {
     
      let page_menu_list = user.user_previleges.filter(p => Number(p.urp_smid) === constants.SubmenuList.SubscriptionPlan)
      if (page_menu_list) {
        setCanView(page_menu_list.find(f => f.urp_type === constants.menuTypes.View)?.urp_smid ? true : false)
        setCanCreate(page_menu_list.find(f => f.urp_type === constants.menuTypes.Create)?.urp_smid ? true : false)
        setCanModify(page_menu_list.find(f => f.urp_type === constants.menuTypes.Modify)?.urp_smid ? true : false)
        setCanRemove(page_menu_list.find(f => f.urp_type === constants.menuTypes.Remove)?.urp_smid ? true : false)
      }
    }
  }, [user]);

  return (
    <React.Fragment>
   {  isLoading?  <Spinners setLoading={setLoading} />:'' }
      
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeletePlan}
        onCloseClick={() => {setDeleteModal(false);setPlan(null);}}
      />
      <PublishModal
        show={publishModal}
        content={publishContent}
        onPublishClick={handlePublishPlan}
        onCloseClick={() => {
          setPublishModal(false);
          setPlan(null);
        }}
      />
      <div className="page-content">
        <Container fluid={true}>
          {/* Render Breadcrumbs */}
          <Row>
            <Col lg={12}>
              <Form>

                <Card className="cardfirstheight">
                  <CardBody>
                    <Row>
                      <Col lg={2}>
                        <div className="mb-3">
                          <Label>Plan Category</Label>
                          <Select
                            value={selectedPlanCategoryName}
                            onChange={(selectedOption) => {
                              handleSelectPlanCategoryName(selectedOption);
                            }}
                            options={optionPlanCategory.map((option) => ({
                              ...option,
                              label: option.label,
                              value: option.id,
                            }))}
                            // styles={customStyles}
                            className="select2-selection"
                          />
                        </div>
                      </Col>
              
                      <Col lg={2}>

                        <div>
                          <Label>Status</Label>
                          <Select
                            value={selectedStatus}
                            onChange={(selectedOption) => {
                              handleSelectStatus(selectedOption);
                            }}
                            options={optionStatus.map((option) => ({
                              label: option.label,
                              value: option.id,
                            }))}
                            className="select2-selection"
                          />
                        </div>

                      </Col>
                      <Col lg={2}>
                        <div className="mb-3">
                          <Label>Publish Status</Label>
                          <Select
                            value={selectedPublish}
                            onChange={(selectedOption) => {
                              handleSelectApproveStatus(selectedOption);
                            }}
                            options={approveStatus.map((option) => ({
                              label: option.label,
                              value: option.id,
                            }))}
                            className="select2-selection"
                          />
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="d-flex flex-wrap gap-2 justify-content-start">
                          <Button
                            type="button"
                            style={{ marginTop: 25 }}
                            className="btn btn-soft-info"
                            onClick={() => {
                              setFilterData({
              
                                selectedPlanCategoryName: selectedPlanCategoryName ? selectedPlanCategoryName.value : 0,
                                selectedStatus: selectedStatus ? selectedStatus.value : 0,
                                selectedPublish: selectedPublish ? selectedPublish.value : 0,
                              
                              });
                            }}
                          >
                            Apply
                          </Button>
                          <Button
                            type="button"
                            style={{ marginTop: 25 }}
                            className="btn btn-soft-danger"
                            onClick={() => {
                              setFilterData({
                    
                                selectedPlanCategoryName: 0,
                                selectedStatus: 0,
                                selectedPublish: 0,
                             
                              });
                 
                              setSelectedPlanCategoryName({ label: "All", value: 0 });
                   
                          
                              setselectedStatus({ label: "All", value: 0 });
                              setSelectedPublish({ label: "All", value: 0 });
                             
                            }}
                          >
                            Clear
                          </Button>
                         
                          {user && user.user_previleges && user.user_previleges.find(f =>
                            Number(f.urp_smid) === constants.SubmenuList.SubscriptionPlan && f.urp_type === constants.menuTypes.Create) && (
                              <Button
                                type="button"
                                style={{ marginTop: 25 }}
                                className="btn btn-secondary"
                                onClick={() => {
                                  localStorage.setItem('isPlanClone', '0');
                                  navigate(`/create-subscription/0`);
                                }}
                              >
                                + Add
                              </Button>
                            )}
                       
                        </div>
                      </Col>



                    </Row>
                  </CardBody>
                </Card>


              </Form>


              <Card className="mt-4">
                <CardBody>

                  <PaginationTableContainer
                    columns={columns}
                    data={planData || []}
                    isPagination={true}
                    isGlobalFilter={true}
                    perPageData={perPageData}
                    totalLength={totalCount}
                    currentPage={currentPage}
                    SearchPlaceholder="Search..."
                    setCurrent={setCurrent}
                    //   setCurrentPage={setCurrentPage}
                    pagination="pagination"
                    // isCustomPageSize={true}
                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                    theadClass="table-light"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}
SubscriptionPlan.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default SubscriptionPlan;